import { defineComponent as _defineComponent } from 'vue'
import { TrackingService } from '@/client/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'NavBarLogo',
  setup(__props) {

function onClickLogo(): void {
  TrackingService.sendEvent('click:ロゴ')
}

return { __sfc: true,onClickLogo }
}

})